import * as Redux from 'redux';
import { IActionCreator } from '../../../interfaces/IActionCreator';
import { Keys } from './types';
import { invokeApi } from '../../../networking/invoker';

export interface IActions {
    getStats: () => void;
}



export const actionCreator: IActionCreator<IActions> = (dispatch: Redux.Dispatch<any>): IActions => {
    return {
        getStats: () => {
            dispatch({
                type: Keys.LOADSTATS,
                payload: invokeApi({
                    path: `/api/Stats`,
                    method: 'GET',
                    responseType: 'json'
                })
            })
        },
    }
}